import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useApi } from "../../../../../hooks/useApi";
import { Textarea } from "../../../../Input/Textarea";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import { DeleteModalLabel } from "../CommentModal/CommentDeleteModal";

interface LinkidMoneySettingModalProps {
  closeEvent: () => void;
  confirmEvent: () => void;
  prevValue?: number;
  userData: {
    uid: string;
    name: string;
    nickname: string;
  };
}

export default function LinkidMoneySettingModal({
  closeEvent,
  prevValue,
  userData,
  confirmEvent,
}: LinkidMoneySettingModalProps) {
  const [execute, setExecute] = useState(false);
  const [reason, setReason] = useState("");

  const { response: lindkidMoneyResponse } = useApi({
    method: "post",
    url: execute ? `user/usemoney` : undefined,
    data: {
      usemoney: prevValue === 1 ? 0 : 1,
      uid: Number(userData?.uid) ?? 0,
      reason,
    },
  });

  useEffect(() => {
    if (
      lindkidMoneyResponse?.status === 200 ||
      lindkidMoneyResponse?.status === 201
    ) {
      closeEvent();
      confirmEvent();

      toast.success(
        prevValue === 1
          ? "링키드 머니 우선 결제가 해제되었습니다."
          : "링키드 머니 우선 결제가 설정되었습니다."
      );
    }
  }, [closeEvent, confirmEvent, lindkidMoneyResponse]);

  return (
    <DefaultModalLayout
      closeEvent={() => closeEvent()}
      confirmEvent={() => setExecute(true)}
      modalTitle={`링키드 머니 우선 결제 ${prevValue === 1 ? "해제" : "설정"}`}
      isSmallModal={true}
      cancelBtnText="취소"
      confirmDisabled={
        reason === "" || userData?.uid === "" || prevValue === 100
      }
    >
      <DeleteModalLabel>
        {prevValue === 1 ? "해제" : "설정"} 사유
      </DeleteModalLabel>

      <Textarea
        placeholder={`${
          prevValue === 1 ? "해제" : "설정"
        } 사유 입력(100글자 이내)`}
        onChange={(e) => setReason(e.target.value)}
        value={reason}
      />
    </DefaultModalLayout>
  );
}
